export const SAVE_PAGE: string = 'SAVE_PAGE';
export const SAVE_PAGE_SUBMIT: string = 'SAVE_PAGE_SUBMIT';
export const SAVE_PAGE_SUCCESS: string = 'SAVE_PAGE_SUCCESS';
export const SAVE_PAGE_FAILURE: string = 'SAVE_PAGE_FAILURE';
export const FETCH_PAGES: string = 'FETCH_PAGES';
export const FETCH_PAGES_SUCCESS: string = 'FETCH_PAGES_SUCCESS';
export const FETCH_PAGES_FAILURE: string = 'FETCH_PAGES_FAILURE';
export const FILTER_PAGES: string = 'FILTER_PAGES';
export const UPDATE_PAGE: string = 'UPDATE_PAGE';
export const UPDATE_PAGE_SUCCESS: string = 'UPDATE_PAGE_SUCCESS';
export const UPDATE_PAGE_FAILURE: string = 'UPDATE_PAGE_FAILURE';
export const SERIALIZE_PAGE: string = 'SERIALIZE_PAGE';
export const CANCEL_PENDING: string = 'CANCEL_PENDING';
export const ARCHIVE_PAGE: string = 'ARCHIVE_PAGE';
export const UNARCHIVE_PAGE: string = 'UNARCHIVE_PAGE';

export const fetchPages = () => ({
  type: FETCH_PAGES,
});

export const filterPages = (filter: string) => ({
  type: FILTER_PAGES,
  filter,
});

export const serializePage = page => ({
  type: SERIALIZE_PAGE,
  page,
});

export const cancelPending = (page, content) => ({
  type: CANCEL_PENDING,
  page,
  content,
});

export const updatePage = page => ({
  type: UPDATE_PAGE,
  page,
});

export const archivePage = page => ({
  type: ARCHIVE_PAGE,
  page,
});

export const unarchivePage = page => ({
  type: UNARCHIVE_PAGE,
  page,
});



// WEBPACK FOOTER //
// ./src/modules/catalog/actions/pages.js